<template>
  <emd-modal
    has-header
    has-footer
    footer-buttons-on-right
    :open="isModalOpen"
    @close="closeClick"
  >
    <template #header>
      <emd-text
        size="section"
        data-testid="modal-header"
      >
        {{ $t('modalheader') }}
      </emd-text>
    </template>
    <template #content>
      <div data-testid="modal-content">
        {{ $t('description-begin') }}
        <b>{{ $t('description-highlight') }}</b>
        {{ $t('description-end') }}
      </div>

      <password-confirmation
        v-model="password"
        label=""
        name="input-password"
        data-testid="input-password"
        class="eu-mt_5"
      />
    </template>
    <template #footer>
      <emd-button
        type="text"
        color="primary"
        data-testid="close-modal"
        @click="closeClick"
      >
        {{ $t('general.exit') }}
      </emd-button>

      <emd-button
        color="primary"
        data-testid="confirm-action"
        :disabled="disabledAction"
        @click="confirmClick"
      >
        {{ $t('cancelLink') }}
      </emd-button>
    </template>
  </emd-modal>
</template>
<script>
import { EmdButton, EmdModal, EmdText } from 'emerald-vue/src/components'

import PasswordConfirmation from '@/components/project/molecules/PasswordConfirmation.vue'

export default {
  name: 'ConfirmCancelModal',

  components: {
    EmdButton,
    EmdModal,
    EmdText,

    PasswordConfirmation
  },

  props: {
    isModalOpen: Boolean,
    isActionDisabled: Boolean
  },

  data () {
    return {
      password: ''
    }
  },

  computed: {
    disabledAction () {
      return this.isActionDisabled || this.password.length < 3
    }
  },

  methods: {
    confirmClick () {
      this.$emit('confirmClick', { password: window.btoa(this.password) })
    },

    closeClick () {
      this.$emit('closeClick')
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "modalheader": "Desativar link de pagamento",
      "description-begin": "Após desativar este link de pagamento,",
      "description-highlight": "não será possível reativá-lo.",
      "description-end": "Você tem certeza que deseja desativar este link?",
      "cancelLink": "Desativar link"
    },
    "en-US": {
      "modalheader": "Disable payment link",
      "description-begin": "After disable this payment link,",
      "description-highlight": "this action cannot be reversed.",
      "description-end": "Are you sure you want to cancel the payment link?",
      "cancelLink": "Disable link"
    }
  }
</i18n>
